//styles
import { useNavigate } from 'react-router-dom';
import * as S from './styles';
import React from 'react';
import { Box, Button } from '@mui/material';
import { getTranslateByKey } from '@/main/services/utils';
import { RoutesConstants } from '@/main/routes/routesConstants';

interface Props {
  styles?: any;
}

export default function NoPermission({ styles }: Props) {
  const classes = S.useStyles();
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      padding="5px"
      alignItems="center"
      style={styles || {}}>
      <img className={classes.iconPermission} />
      <span className={classes.messageResultFound}>
        {getTranslateByKey('information.noPermission', true)}
      </span>
      <Button
        style={{
          marginTop: 30,
          marginLeft: 0,
          maxWidth: '10rem',
          display: 'block'
        }}
        onClick={() => navigate(RoutesConstants.home)}>
        {getTranslateByKey('information.backToHome')}
      </Button>
    </Box>
  );
}
